import { useLayoutEffect, useRef } from "react"
import gsap from "gsap"
import { SplitText } from "gsap/SplitText"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger, SplitText)

const FadeIn = ({ children }: { children: React.ReactNode }) => {

	const containerRef = useRef<HTMLDivElement>(null)
	useLayoutEffect(() => {
		// ⚠️ DO NOT REMOVE: Prevents SSR errors in production
		if (typeof window === 'undefined' || !containerRef.current) return

		let ctx: gsap.Context | undefined
		let cancelled = false

		const init = () => {
			if (cancelled || !containerRef.current) return

			ctx = gsap.context(() => {
				const title = containerRef.current?.querySelector(".f-y")
				// ⚠️ DO NOT REMOVE: Validates element before SplitText
				if (!title || !(title instanceof Element)) return

				// Split text into lines
				const titleSplit = new SplitText(title, { type: "lines", aria: "none" })
				const titleLines = titleSplit.lines

				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: containerRef.current,
						start: "top 80%", // Start animation when 80% of the element is visible
						toggleActions: "play none none reverse", // Play animation on enter, reverse on leave
					},
				})

				tl.fromTo(
					titleLines,
					{ clipPath: "inset(100% 0% 0% 0%)", y: "40%", opacity: 0 },
					{
						clipPath: "inset(0% 0% 0% 0%)",
						y: "0%",
						opacity: 1,
						stagger: 0.05,
						ease: "power3.out",
						duration: 0.6,
					}
				)
			}, containerRef)
		}

		// Split after fonts load so line breaks match final metrics (prevents CLS).
		if (document.fonts?.ready) {
			document.fonts.ready.then(init)
		} else {
			init()
		}

		return () => {
			cancelled = true
			ctx?.revert()
		}
	}, [])

  return (
    <div ref={containerRef}> 
      {children} 
    </div>
  );
}

export default FadeIn;
